function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareDesktop = function SvgShareDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1.33h22.006c1.52 0 2.75 1.282 2.75 2.864V20.37c0 1.582-1.23 2.863-2.75 2.863H26.98c.76 0 1.375.641 1.375 1.432 0 .79-.616 1.431-1.375 1.431H13.226c-.76 0-1.375-.64-1.375-1.431 0-.79.616-1.432 1.375-1.432H9.1c-1.519 0-2.75-1.281-2.75-2.863V3.194C6.35 1.612 7.58.33 9.1.33zm0 2.864V20.37h22.006V3.194ZM21.478 8.92c-5.626 0-8.252 2.505-8.252 10.02 3.001-6.084 8.252-5.726 8.252-5.726v1.99c0 .656.73 1.02 1.221.607l4.932-4.136a.8.8 0 0 0 0-1.216l-4.932-4.137c-.49-.412-1.22-.048-1.22.608z",
    style: {
      strokeWidth: 1.53069
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      wordSpacing: 0,
      fillOpacity: 1,
      stroke: "none"
    },
    x: -0.237,
    y: 39.675
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.237,
    y: 39.675,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "SHARE")));
};
export default SvgShareDesktop;